var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8203 30.9155V22.0093C51.8203 13.2855 44.7238 6.18896 36 6.18896C27.2762 6.18896 20.1797 13.2855 20.1797 22.0093V30.9155H27.2109V22.0093C27.2109 17.1632 31.1523 13.2202 36 13.2202C40.8477 13.2202 44.7891 17.1632 44.7891 22.0093V30.9155H51.8203Z",
    fill: "#F30002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 36.189V64.4312C13.1484 65.4028 13.9346 66.189 14.9062 66.189H57.0938C58.0654 66.189 58.8516 65.4028 58.8516 64.4312V36.189C58.8516 35.2174 58.0654 34.4312 57.0938 34.4312H14.9062C13.9346 34.4312 13.1484 35.2174 13.1484 36.189ZM22.4525 54.2821L29.4838 47.2509C30.1704 46.5643 31.2829 46.5643 31.9695 47.2509L37.7578 53.0392L44.0612 46.7358H41.2734C40.3018 46.7358 39.5156 45.9496 39.5156 44.978C39.5156 44.0064 40.3018 43.2202 41.2734 43.2202H48.3047C49.2763 43.2202 50.0625 44.0064 50.0625 44.978V52.0093C50.0625 52.9809 49.2763 53.7671 48.3047 53.7671C47.3331 53.7671 46.5469 52.9809 46.5469 52.0093V49.2215L39.0006 56.7678C38.314 57.4544 37.2015 57.4544 36.5149 56.7678L30.7266 50.9793L24.9381 56.7678C24.2515 57.4544 23.139 57.4544 22.4524 56.7678C21.7658 56.0812 21.7658 54.9687 22.4525 54.2821Z",
    fill: "#161614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.5d4f03507c954da57ad3f98d15e20b72.svg";
export { ForwardRef as ReactComponent };